import { createRoot } from 'react-dom/client'
import { App } from './App'
import { ToastProvider } from './components/ui'
import { checkSession } from './lib/auth'
import './styles.css'

checkSession()

createRoot(document.getElementById('root')!).render(
  <ToastProvider><App /></ToastProvider>,
)
